import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createSlots as _createSlots, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49edb924"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "job_card" }
const _hoisted_2 = { class: "job_card_header" }
const _hoisted_3 = { class: "job_card_header_check" }
const _hoisted_4 = ["for"]
const _hoisted_5 = ["id"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox_text" }, null, -1))
const _hoisted_7 = { class: "job_card_contents" }
const _hoisted_8 = { class: "job_card_contents_employment_status" }
const _hoisted_9 = { class: "job_card_contents_catch_copy" }
const _hoisted_10 = { class: "job_card_contents_annual_income" }
const _hoisted_11 = {
  key: 0,
  class: "job_card_contents_description"
}
const _hoisted_12 = {
  key: 1,
  class: "job_card_contents_description"
}
const _hoisted_13 = { class: "job_card_contents_company_name" }
const _hoisted_14 = { class: "job_card_contents_company_location" }
const _hoisted_15 = { class: "job_card_contents_recommended_points" }
const _hoisted_16 = {
  key: 0,
  class: "job_card_contents_recommended_points_item"
}
const _hoisted_17 = {
  key: 1,
  class: "job_card_contents_recommended_points_item"
}
const _hoisted_18 = {
  key: 2,
  class: "job_card_contents_recommended_points_item"
}
const _hoisted_19 = {
  key: 3,
  class: "job_card_contents_recommended_points_item"
}
const _hoisted_20 = {
  key: 4,
  class: "job_card_contents_recommended_points_item"
}
const _hoisted_21 = {
  key: 5,
  class: "job_card_contents_recommended_points_item"
}
const _hoisted_22 = {
  key: 6,
  class: "job_card_contents_recommended_points_item"
}
const _hoisted_23 = { class: "job_card_footer" }
const _hoisted_24 = { class: "job_card_footer_button" }
const _hoisted_25 = { class: "job_card_footer_button_apply" }
const _hoisted_26 = { class: "job_card_footer_button_detail" }
const _hoisted_27 = {
  key: 0,
  class: "job_card_footer_button_pending"
}
const _hoisted_28 = { class: "job_card_footer_number" }
const _hoisted_29 = { class: "job_card_footer_number_label" }

import BaseButton from '@/components/BaseButton.vue';
import BaseThreeButtonModal from '@/components/BaseThreeButtonModal.vue';
import BaseJobBadge from '@/components/BaseJobBadge.vue';
import { OrderCard } from '@/types';
import { computed, PropType, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderCard',
  props: {
  order: {
    type: Object as PropType<OrderCard>,
    required: true,
  },
  hasConsiderButton: {
    type: Boolean,
    default: true,
  },
  hasCheckBox: {
    type: Boolean,
    default: true,
  },
},
  emits: ["change", "apply", "toggleConsider", "navigateDetail"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'change', order: OrderCard): void;
  (e: 'apply', orderId: number): void;
  (e: 'toggleConsider', orderId: number): void;
  (e: 'navigateDetail'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props



const showApplyConfirm = ref(false);



const checked = computed({
  get: () => props.order.checked,
  set: (value) => emits('change', { ...props.order, checked: value }),
});

const applyConfirm = () => {
  showApplyConfirm.value = true;
};

const apply = () => {
  showApplyConfirm.value = false;
  emits('apply', props.order.orderId);
};

const toggleConsider = () => {
  emits('toggleConsider', props.order.orderId);
};
const navigateDetail = () => {
  emits('navigateDetail');
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (props.hasCheckBox)
            ? (_openBlock(), _createElementBlock("label", {
                key: 0,
                class: "checkbox",
                for: 'card_' + props.order.orderId
              }, [
                _withDirectives(_createElementVNode("input", {
                  class: "checkbox_input",
                  id: 'card_' + props.order.orderId,
                  type: "checkbox",
                  name: "card",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(checked) ? (checked).value = $event : null))
                }, null, 8, _hoisted_5), [
                  [_vModelCheckbox, _unref(checked)]
                ]),
                _hoisted_6
              ], 8, _hoisted_4))
            : _createCommentVNode("", true)
        ]),
        _createVNode(BaseJobBadge, {
          badge: props.order.badge,
          aiMatchBadge: props.order.aiMatchBadge,
          unread: props.order.unreadFlg
        }, null, 8, ["badge", "aiMatchBadge", "unread"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(props.order.empTypeName) + " " + _toDisplayString(props.order.ocupctgName), 1),
        _createElementVNode("div", _hoisted_9, _toDisplayString(props.order.catchCopy), 1),
        _createElementVNode("div", _hoisted_10, _toDisplayString(props.order.salary), 1),
        (props.order.aiRecommendation)
          ? (_openBlock(), _createElementBlock("pre", _hoisted_11, _toDisplayString(props.order.aiRecommendation), 1))
          : (_openBlock(), _createElementBlock("pre", _hoisted_12, _toDisplayString(props.order.comment), 1)),
        _createElementVNode("div", _hoisted_13, _toDisplayString(props.order.companyName), 1),
        _createElementVNode("div", _hoisted_14, _toDisplayString(props.order.location), 1),
        _createElementVNode("div", _hoisted_15, [
          (props.order.recommendedPointWeekendOffFlg)
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, "土日祝休み"))
            : _createCommentVNode("", true),
          (props.order.recommendedPointNoOvertimeFlg)
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, "残業なし"))
            : _createCommentVNode("", true),
          (props.order.recommendedPointOvertimeFlg)
            ? (_openBlock(), _createElementBlock("span", _hoisted_18, "残業月20時間以内"))
            : _createCommentVNode("", true),
          (props.order.recommendedPointFlextimeFlg)
            ? (_openBlock(), _createElementBlock("span", _hoisted_19, "フレックスタイム制"))
            : _createCommentVNode("", true),
          (props.order.recommendedPointHomeBasedFlg)
            ? (_openBlock(), _createElementBlock("span", _hoisted_20, "在宅・リモートワーク"))
            : _createCommentVNode("", true),
          (props.order.recommendedPointSideWorkFlg)
            ? (_openBlock(), _createElementBlock("span", _hoisted_21, "副業・兼業OK"))
            : _createCommentVNode("", true),
          (props.order.recommendedPointNoRelocationFlg)
            ? (_openBlock(), _createElementBlock("span", _hoisted_22, "転勤なし"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createVNode(BaseButton, {
              theme: "primary",
              type: "button",
              onClick: applyConfirm
            }, {
              default: _withCtx(() => [
                _createTextVNode("応募する")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_router_link, {
              to: { name: 'g00', params: { orderId: props.order.orderId } }
            }, {
              default: _withCtx(() => [
                _createVNode(BaseButton, {
                  theme: "secondary",
                  type: "button",
                  onClick: navigateDetail
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("詳細を見る")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          (props.hasConsiderButton)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("span", {
                  class: _normalizeClass(["job_card_footer_button_pending_label", { 'is-pending': props.order.considerFlg }]),
                  onClick: toggleConsider
                }, " 検討中 ", 2)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("span", _hoisted_29, "求人No." + _toDisplayString(props.order.orderId), 1)
        ])
      ])
    ]),
    (showApplyConfirm.value)
      ? (_openBlock(), _createBlock(BaseThreeButtonModal, {
          key: 0,
          "left-btn-text": 'キャンセル',
          "right-btn-text": '応募する',
          "bottom-btn-disabled": true,
          onLeftBtnClick: _cache[1] || (_cache[1] = () => (showApplyConfirm.value = false)),
          onRightBtnClick: apply
        }, _createSlots({
          large: _withCtx(() => [
            _createTextVNode("応募します。よろしいですか？")
          ]),
          _: 2
        }, [
          (props.order.considerFlg)
            ? {
                name: "default",
                fn: _withCtx(() => [
                  _createTextVNode("応募すると検討中リストからは削除されます。")
                ]),
                key: "0"
              }
            : undefined
        ]), 1024))
      : _createCommentVNode("", true)
  ], 64))
}
}

})